var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, EventEmitter, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, FormGroup } from '@angular/forms';
import { HasSubscriptions } from '../../has-subscriptions';
import { DomManipulationService } from '../../../services/dom-manipulation/dom-manipulation.service';
var MinMaxSliderComponent = /** @class */ (function (_super) {
    __extends(MinMaxSliderComponent, _super);
    function MinMaxSliderComponent(domManipulationService) {
        var _this = _super.call(this) || this;
        _this.domManipulationService = domManipulationService;
        _this.propagateChange = function () { };
        _this.validateFn = function () { };
        _this.setDisabledState = function () { };
        // TODO: Translations
        // Component dependent, is not the actual postfix/prefix passed to the ion slider though. We use a middle man so that values can be customized
        _this.postfix = ' or More';
        _this.prefix = 'Less than ';
        _this._minMax = {};
        // The value that we want to display when they haven't selected a value
        _this.anyValueText = 'Any value';
        _this.minMaxChange = new EventEmitter();
        _this._hardCompRef = {};
        return _this;
    }
    MinMaxSliderComponent.prototype.ngOnInit = function () {
    };
    MinMaxSliderComponent.prototype.ngOnChanges = function (changes) {
        this._calcValues();
    };
    MinMaxSliderComponent.prototype.rangeChanged = function (a) {
        var newRange = {};
        if (a.from_value !== this.values[0])
            newRange.min = a.from_value;
        if (a.to_value !== this.values[this.values.length - 1])
            newRange.max = a.to_value;
        this.propagateChange(newRange);
        this.minMaxChange.next(newRange);
    };
    MinMaxSliderComponent.prototype.onChange = function (a) {
        this._updateValues(a);
    };
    // TODO: this hurts me so
    // Use this to dynamically add classes that hide/show the relevant labels as well as putting in the custom value if necessary
    MinMaxSliderComponent.prototype._updateValues = function (a) {
        // We need to manually do it like this because modifying the prefix and postfix variables into the component causes the component to reset
        // each time the prefix/postfix changes
        this.modifiyingClass = 'single-only';
        // No values selected, all values are legal
        if (a.from_percent === 0 && a.to_percent === 100 && this.domManipulationService.querySelector(this._sliderRef, '.irs-single')) {
            this.domManipulationService.querySelectorAndSetInnerHTML(this._sliderRef, '.irs-single', this.anyValueText);
        }
        else if (a.from_percent > 0 && a.to_percent === 100 && this.domManipulationService.querySelector(this._sliderRef, '.irs-from')) {
            this.modifiyingClass = 'from-only';
            var val = '';
            if (this.toMagnitudes)
                val = this.toMagnitudes(a.from_value) + this.postfix;
            else
                val = a.from_value + this.postfix;
            this.domManipulationService.querySelectorAndSetInnerHTML(this._sliderRef, '.irs-from', this.unit ? val + ' ' + this.unit : val);
        }
        else if (a.from_percent === 0 && a.to_percent < 100 &&
            this.domManipulationService.querySelector(this._sliderRef, '.irs-to')) {
            this.modifiyingClass = 'to-only';
            var val = '';
            if (this.toMagnitudes)
                val = this.prefix + this.toMagnitudes(a.to_value);
            else
                val = this.prefix + a.to_value;
            this.domManipulationService.querySelectorAndSetInnerHTML(this._sliderRef, '.irs-to', this.unit ? val + ' ' + this.unit : val);
        }
        else {
            var curVal = this.domManipulationService.querySelector(this._sliderRef, '.irs-single').innerHTML;
            this.domManipulationService.querySelectorAndSetInnerHTML(this._sliderRef, '.irs-single', this.unit ? curVal + ' ' + this.unit : curVal);
        }
        // Maximum value text should be updated every time the price value is updated since the largest value is max_safe_integer
        var indexOffset = this._getIndexOffset();
        var text = this.toMagnitudes ? this.toMagnitudes(this.values[this.values.length - indexOffset]) + '+' : this.values[this.values.length - indexOffset] + '+';
        this.domManipulationService.querySelectorAndSetInnerHTML(this._sliderRef, '.irs-max', text);
    };
    Object.defineProperty(MinMaxSliderComponent.prototype, "minMax", {
        get: function () {
            return this._minMax;
        },
        set: function (val) {
            this._minMax = val;
            this.propagateChange(this._minMax);
        },
        enumerable: true,
        configurable: true
    });
    // Called when form is initialized, with form model's initial value
    MinMaxSliderComponent.prototype.writeValue = function (value) {
        if (value)
            this.minMax = value;
        this._calcValues();
    };
    // Access to a function that informs the outside world about changes
    MinMaxSliderComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    // Callback whenever a form input is touched (ex: on blur, fires touch event)
    MinMaxSliderComponent.prototype.registerOnTouched = function () {
        // TODO: what is this
    };
    MinMaxSliderComponent.prototype._calcValues = function () {
        var _this = this;
        this.initialMin = (this.minMax.min !== undefined && this.values.indexOf(this.minMax.min)) || 0;
        this.initialMax = (this.minMax.max !== undefined && this.values.indexOf(this.minMax.max)) || this.values.length - 1;
        var toPercent = this.initialMax / (this.values.length - 1) * 100;
        // Need this so that we give a second for the page to load first, before we update it
        setTimeout(function () {
            _this._updateValues({ from_percent: _this.initialMin, to_percent: toPercent, from_value: _this.minMax.min, to_value: _this.minMax.max });
            var indexOffset = _this._getIndexOffset();
            var text = _this.toMagnitudes ? _this.toMagnitudes(_this.values[_this.values.length - indexOffset]) + '+' : _this.values[_this.values.length - indexOffset] + '+';
            _this.domManipulationService.querySelectorAndSetInnerHTML(_this._sliderRef, '.irs-max', text);
        });
    };
    MinMaxSliderComponent.prototype._getIndexOffset = function () {
        return (this.values[this.values.length - 1] === Number.MAX_SAFE_INTEGER) ? 2 : 1;
    };
    return MinMaxSliderComponent;
}(HasSubscriptions));
export { MinMaxSliderComponent };
